import Vue from 'vue'
import RecebimentoVuex from 'vuex'

const fontePagadoraSelected: String = ''

Vue.use(RecebimentoVuex)

const getters = {
  FONTE_PAGADORA_SELECTED: (state: any) => state.fontePagadoraSelected,
}

const actions = { }

const mutations = {
  SET_FONTE_PAGADORA_SELECTED(state: any, value: String) {
    state.fontePagadoraSelected = value
  },
}

export default new RecebimentoVuex.Store({
  state: {
    fontePagadoraSelected,
  },
  getters,
  actions,
  mutations,
})
